module.exports = __webpack_public_path__ + "img/6_78.4cb8d3da.png";